import { render } from "./Button.vue?vue&type=template&id=b9d631aa"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
script.render = render

export default script